const getProperty = () => {
  const properties = {
    PROD: 'UA-38165814-1',
    TEST: 'UA-106701321-1',
    DEV: '/dev/null',
  };

  if (window.location.pathname.indexOf('raise.com') !== -1) {
    return properties.PROD;
  } else if (window.location.pathname.indexOf('raise-test.com') !== -1) {
    return properties.TEST;
  }
  return properties.DEV;
};

let initialized = false;

const init = () => {
  const gaExists = document.querySelector('script[src="//www.google-analytics.com/analytics.js"]') !== null;
  if (!gaExists) {
    (function(i, s, o, g, r, a, m) { i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function() { (i[r].q = i[r].q || []).push(arguments); }; i[r].l = 1 * new Date; a = s.createElement(o); m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m); }(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga')); // eslint-disable-line
  }

  const property = getProperty();
  window.ga('create', property, 'auto');
  initialized = true;
};

const wrapInit = (fn) => (...args) => {
  if (!initialized) init();
  fn(...args);
};

const sendEvent = wrapInit((category, action, label) => {
  window.ga('send', 'event', category, action, label);
});

export default {
  sendEvent,
};
